(function() {
  'use strict';
  
  function setup() {
  	var page = window.location.pathname;
    switch (page) {
      case '/':
        setupHomePage();
        break;
      case '/pages/meet-the-baker':
        setupPage();
        break;
    }
    
    if (page.includes('/products/')) {
      setupProductPage();
    }
    
    var socialLinks = document.querySelectorAll('a.social-icons__link');
    Array.prototype.forEach.call(socialLinks, function(link) {
      link.target = '_blank';
    });
  }
  
  function setupHomePage() {
    var html = '<div style="text-align:center; margin-top:60px;"><a href="/pages/testimonials" class="btn">Read More</a></div>';
    document.querySelector('.quotes-wrapper').insertAdjacentHTML('afterend', html);
  }

  function setupPage() {
    // Adjust Content
    var h1 = document.querySelector('h1');
    var content = document.querySelector('.page-content');
    var p = content.querySelector('p');
    p.insertAdjacentElement('afterbegin', h1);
    
    // Add Root Class Name based on the page
    // This is used by [bakery.css].
    var uriComponents = window.location.pathname.split('/');
    var page = uriComponents[uriComponents.length-1];
    var classList = document.documentElement.classList;
    classList.add('custom-page');
    classList.add(page);
    
    // Show the page, this is hidden from [page.liquid] by default
    // otherwise content flashes on screen.
    content.style.display = 'flex';
  }
  
  function setupProductPage() {
    let count = 0;
    // console.log('setupProductPage');
    let interval = window.setInterval(function() {
      if (document.querySelector('[data-section-id="product-recommendations"] a') === null) {
        // console.log('waiting for content');
        return;
      }
      window.clearInterval(interval);
      
      // Hide Delivery Fee if recommended
      let selector = '[data-section-id="product-recommendations"] a[href*="delivery-fee"]';
      const deliveryFee = document.querySelector(selector);
      if (deliveryFee === null || deliveryFee.parentNode.parentNode.tagName !== 'LI') {
        // console.log('delivery fee not found');
        return;
      }
      deliveryFee.parentNode.parentNode.style.display = 'none';

      // Set Grid items from 25% width to 33% (this code runs but layout ends up looking worse)
      //
//       selector = '[data-section-id="product-recommendations"] .grid__item.medium-up--one-quarter';
//       const items = document.querySelectorAll(selector);
//       for (const item of items) {
//         item.className = 'grid__item small--one-third medium-up--one-third';
//       }
    }, 100);
  }
  
  // Run setup once page is ready
  if (document.readyState === 'interactive' || document.readyState === 'complete') {
    setup();
  } else {
    document.addEventListener('DOMContentLoaded', setup);
  }
})();